import React, { createContext } from 'react';

const OuterElementContext = createContext({});

export default OuterElementContext;
